import { Loader2, PlayCircle } from "lucide-react";
import React from "react";

function PlacementTest({
  enrollment = null,
  student_id = null,
  setLoading = () => null,
  loading = false,
  handleStartProcess = null,
}) {
  const process = `Placement Test`;
  const routine = `placement-test`;

  if (
    !enrollment.placement_test_status ||
    enrollment.placement_test_status === "Not started"
  ) {
    return (
      <div className="flex flex-1 w-full flex-col items-start justify-start text-center gap-4 px-4">
        <div className="flex w-96 flex-col items-center justify-center text-center gap-4 border border-gray-200 bg-slate-50 rounded-md p-4">
          {loading ? (
            <div className="w-full bg-slate-300 text-slate-500 border border-slate-400 hover:bg-slate-400 hover:text-white rounded-md py-4 px-4 my-2 px-2 h-6 flex flex-row items-center justify-between text-xs gap-1">
              <strong>Please wait...</strong>
              <Loader2 className="animate-spin" size={14} />
            </div>
          ) : (
            <button
              type="button"
              disabled={loading}
              onClick={() => handleStartProcess(routine)}
              className="w-full bg-green-300 text-green-800 border border-green-400 hover:bg-green-400 hover:text-white rounded-md py-4 px-4 my-2 px-2 h-6 flex flex-row items-center justify-between text-xs gap-1"
            >
              <strong>Start {process} Process</strong>
              <PlayCircle size={18} />
            </button>
          )}
          <p className="text-xs text-gray-500 text-left px-2 border-t pt-4">
            This action will send an email to the student with a link to
            complete the {process} form.
          </p>
        </div>
      </div>
    );
  } else if (enrollment.placement_test_status === "started") {
    return (
      <div className="flex flex-1 w-full flex-col items-start justify-start text-center gap-4 px-4">
        <h2 className="text-md font-bold w-full text-left border-b border-gray-200 pb-2">
          Placement Test
          <span className="text-green-500"> - Started</span>
        </h2>
        <div className="flex w-96 flex-col items-center justify-center text-center gap-4 border border-gray-200 bg-slate-50 rounded-md p-4">
          {loading ? (
            <div className="w-full bg-slate-300 text-slate-500 border border-slate-400 hover:bg-slate-400 hover:text-white rounded-md py-4 px-4 my-2 px-2 h-6 flex flex-row items-center justify-between text-xs gap-1">
              <strong>Please wait...</strong>
              <Loader2 className="animate-spin" size={14} />
            </div>
          ) : (
            <button
              type="button"
              disabled={loading}
              onClick={() => handleStartProcess(routine)}
              className="w-full bg-green-300 text-green-800 border border-green-400 hover:bg-green-400 hover:text-white rounded-md py-4 px-4 my-2 px-2 h-6 flex flex-row items-center justify-between text-xs gap-1"
            >
              <strong>Resend placement test e-mail</strong>
              <PlayCircle size={18} />
            </button>
          )}
        </div>
      </div>
    );
  } else if (enrollment.placement_test_status === "scheduled") {
    return (
      <div className="flex flex-1 w-full flex-col items-start justify-start text-center gap-4 px-4">
        <h2 className="text-md font-bold w-full text-left border-b border-gray-200 pb-2">
          Placement Test
          <span className="text-green-500"> - Scheduled</span>
        </h2>
        <div className="flex w-full flex-row items-center justify-start text-center gap-4 border border-gray-200 bg-slate-50 rounded-md p-4">
          <p className="text-xs text-left">
            <strong>Appointment Test</strong> set to{" "}
            {enrollment.appointment_date}.
          </p>
        </div>
      </div>
    );
  } else if (enrollment.placement_test_status === "finished") {
    return (
      <div className="flex flex-1 w-full flex-col items-start justify-start text-center gap-4 px-4">
        <h2 className="text-md font-bold w-full text-left border-b border-gray-200 pb-2">
          Placement Test
          <span className="text-red-500"> - Concluded</span>
        </h2>
        <div className="flex w-full flex-row items-center justify-start text-center gap-4 border border-gray-200 bg-slate-50 rounded-md p-4">
          <p className="text-xs text-left">
            <strong>Final Level: </strong>
            {enrollment.final_level}
          </p>
        </div>
      </div>
    );
  }
}

export default PlacementTest;
